<script setup lang="ts">
import { Icon } from '@iconify/vue'

defineProps<{ label: string; icon?: string }>()
</script>

<template>
  <div class="rl-link-item">
    {{ label }}
    <Icon class="rl-link-item__icon" :icon="`material-symbols:${icon || 'open-in-new'}`" height="20" width="20" />
  </div>
</template>

<style scoped lang="scss">
.rl-link-item {
  width: 100%;
  padding: var(--spacing-spacing-sm);
  border-radius: var(--spacing-spacing-2xs);
  display: inline-flex;
  justify-content: space-between;
  align-items: center;
  gap: var(--spacing-spacing-xs);
  color: var(--text-primary);
  background-color: var(--fill-tertiary);
  font-size: var(--font-size-body-compact);
  line-height: 20px;
  cursor: pointer;

  &__icon {
    color: var(--text-tertiary);
  }
}
</style>
